import { Head, useForm } from "@inertiajs/react"
import type { FormEvent } from "react"
import { Button } from "@/components/ui/button"
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card"
import { AuthLayout } from "@/layouts/auth-layout"

interface ResetPasswordProps {
  token: string
  welcome?: boolean
  flash?: { alert?: string }
}

function ResetPassword({ token, welcome, flash }: ResetPasswordProps) {
  const { data, setData, put, processing } = useForm({
    password: "",
    password_confirmation: "",
  })

  function handleSubmit(e: FormEvent) {
    e.preventDefault()
    put(`/passwords/${token}`)
  }

  return (
    <>
      <Head title={welcome ? "Créez votre mot de passe" : "Réinitialiser le mot de passe"} />
      <Card className="w-full pt-4 pb-4">
        <CardHeader>
          <CardTitle className="text-center">{welcome ? "Bienvenue sur Kaptcher" : "Nouveau mot de passe"}</CardTitle>
          <CardDescription className="text-center">
            {welcome
              ? "Créez votre mot de passe pour accéder à votre espace"
              : "Entrez votre nouveau mot de passe ci-dessous"}
          </CardDescription>
        </CardHeader>
        <CardContent className="grid gap-4">
          <div className="min-h-5 text-sm text-center">
            {flash?.alert && <p className="text-destructive">{flash.alert}</p>}
          </div>
          <form onSubmit={handleSubmit} className="grid gap-4">
            <div className="grid gap-2">
              <Label htmlFor="password">{welcome ? "Mot de passe" : "Nouveau mot de passe"}</Label>
              <Input
                id="password"
                type="password"
                value={data.password}
                onChange={(e) => setData("password", e.target.value)}
                required
                autoFocus
                autoComplete="new-password"
                maxLength={72}
              />
            </div>
            <div className="grid gap-2">
              <Label htmlFor="password_confirmation">Confirmer le mot de passe</Label>
              <Input
                id="password_confirmation"
                type="password"
                value={data.password_confirmation}
                onChange={(e) => setData("password_confirmation", e.target.value)}
                required
                autoComplete="new-password"
                maxLength={72}
              />
            </div>
            <Button type="submit" size="lg" disabled={processing} className="w-full">
              {processing ? "Enregistrement..." : welcome ? "Créer mon mot de passe" : "Enregistrer le mot de passe"}
            </Button>
          </form>
        </CardContent>
      </Card>
    </>
  )
}

ResetPassword.layout = (page: React.ReactNode) => <AuthLayout>{page}</AuthLayout>

export default ResetPassword
